// Як показувати рахунок поєдинку в сітці (Bracket2…Bracket64).
// Бали приходять як '', null, 0, '0' або число — "0 : 0" та ": " без даних не показуємо.

function isEmpty(value) {
  return value === undefined || value === null || String(value).trim() === '';
}

function isZero(value) {
  return !isEmpty(value) && Number(value) === 0;
}

export function scoreClass(bluePoints, redPoints) {
  const blueEmpty = isEmpty(bluePoints);
  const redEmpty = isEmpty(redPoints);
  const noScore = (blueEmpty || isZero(bluePoints)) && (redEmpty || isZero(redPoints));

  return {
    // клас .hidden для цих span вже є в bracket-common.scss
    hidden: noScore,
    'blue-missing': !noScore && blueEmpty,
    'red-missing': !noScore && redEmpty,
  };
}
